module.exports = fox._r("images/login-bg.jpg", __webpack_public_path__ + "images/login-bg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/login-bg.jpg
// module id = 981
// module chunks = 4